export var menuItems = {
  "data": [

    {
      "path": "/",
      "title": "Dashboard",
      "icon": "stroke-board",
      "iconf": "fill-board",
      "icony": "fa fa-home",
      "type": "link",
      "active": false,
      "module_id": 1
    },

    {
      "path": "/staffs",
      "title": "Manage Staffs",
      "icon": "stroke-internationalization",
      "iconf": "fill-internationalization",
      "icony": "icofont icofont-people",
      "type": "link",
      "active": false,
      "module_id": 2
    },

    {
      "path": "/sims",
      "title": "Manage SIMs",
      "icon": "stroke-internationalization",
      "iconf": "fill-internationalization",
      "icony": "icon-mobile",
      "type": "link",
      "active": false,
      "module_id": 3
    },

    {
      "title": "Manage Vendors",
      "icon": "stroke-internationalization",
      "iconf": "fill-internationalization",
      "icony": "icofont icofont-businessman",
      "type": "sub",
      "active": false,
      "module_id": 4,
      "children": [
        {
          "path": "/vendors",
          "title": "Vendors",
          "type": "link",
          "active": false
        },
        {
          "path": "/suppliers",
          "title": "Suppliers",
          "type": "link",
          "active": false
        },
      ]
    },

    {
      "path": "/raw_materials",
      "title": "Raw Materials",
      "icon": "stroke-internationalization",
      "iconf": "fill-internationalization",
      "icony": "icofont icofont-tools-alt-2",
      "type": "link",
      "active": false,
      "module_id": 5
    },

    {
      "title": "Manage Boards",
      "icon": "stroke-knowledgebase",
      "iconf": "fill-knowledgebase",
      "icony": "icofont icofont-architecture-alt",
      "type": "sub",
      "active": false,
      "module_id": 6,
      "children": [
        {
          "path": "/boards",
          "title": "Boards",
          "type": "link",
          "active": false
        },
        {
          "path": "/failed_boards",
          "title": "Firmware Failed",
          "type": "link",
          "active": false
        },
        {
          "path": "/enclosure",
          "title": "Enclosure",
          "type": "link",
          "active": false
        },
        {
          "path": "/board_batches",
          "title": "Board Batches",
          "type": "link",
          "active": false
        },
      ]
    },

    {
      "path": "/view_devices",
      "title": "Manage Devices",
      "icon": "stroke-knowledgebase",
      "iconf": "fill-knowledgebase",
      "icony": "icofont icofont-company",
      "type": "link",
      "active": false,
      "module_id": 7
    },

    {
      "path": "/view_vehicles",
      "title": "Manage Vehicles",
      "icon": "stroke-knowledgebase",
      "iconf": "fill-knowledgebase",
      "icony": "icofont icofont-car",
      "type": "link",
      "active": false,
      "module_id": 8
    },

    {
      "title": "Service Management",
      "icon": "stroke-knowledgebase",
      "iconf": "fill-knowledgebase",
      "icony": "icofont icofont-support",
      "type": "sub",
      "active": false,
      "module_id": 9,
      "children": [
        {
          "path": "/complaint_management",
          "title": "Pending & New",
          "type": "link",
          "active": false
        },
        // {
        //   "path": "/support_services",
        //   "title": "Support Services",
        //   "type": "link",
        //   "active": false
        // },
        {
          "path": "/replacement_devices",
          "title": "Replacement",
          "type": "link",
          "active": false
        },
        {
          "path": "/complaint_log",
          "title": "Completed & Logs",
          "type": "link",
          "active": false
        },
        {
          "path": "/pending_service_payments",
          "title": "Pending Payments",
          "type": "link",
          "active": false
        },
        {
          "path": "/buy_back_devices",
          "title": "Buy Back Devices",
          "type": "link",
          "active": false
        },
      ]
    },

    {
      "title": "Support Management",
      "icon": "stroke-knowledgebase",
      "iconf": "fill-knowledgebase",
      "icony": "icofont icofont-live-support",
      "type": "sub",
      "active": false,
      "module_id": 16,
      "children": [
        {
          "path": "/supports",
          "title": "Pending & New",
          "type": "link",
          "active": false
        },
        {
          "path": "/completed_supports",
          "title": "Completed & Logs",
          "type": "link",
          "active": false
        },
        {
          "path": "/api_requesters",
          "title": "API Requesters",
          "type": "link",
          "active": false
        },
      ]
    },

    {
      "title": "Device Renewals",
      "icon": "stroke-knowledgebase",
      "iconf": "fill-knowledgebase",
      "icony": "icofont icofont-automation",
      "type": "sub",
      "active": false,
      "module_id": 11,
      "children": [
        {
          "path": "/all_devices",
          "title": "All Devices",
          "type": "link",
          "active": false
        },
        {
          "path": "/expired_devices",
          "title": "Expired Devices",
          "type": "link",
          "active": false
        },
        {
          "path": "/enquiry_devices",
          "title": "Enquiry Devices",
          "type": "link",
          "active": false
        },
        {
          "path": "/requested_devices",
          "title": "Requested Devices",
          "type": "link",
          "active": false
        },
        {
          "path": "/recharged_devices",
          "title": "Recharged Devices",
          "type": "link",
          "active": false
        },
        {
          "path": "/upcomimg_expire_devices",
          "title": "Upcoming Expire Devices",
          "type": "link",
          "active": false
        },
        {
          "path": "/renewed_devices",
          "title": "Renewed Devices",
          "type": "link",
          "active": false
        },
        {
          "path": "/extended_devices",
          "title": "Extended Devices",
          "type": "link",
          "active": false
        },
        {
          "path": "/pending_payments",
          "title": "Pending Payments",
          "type": "link",
          "active": false
        },
      ]
    },

    {
      "title": "Accounts",
      "icon": "stroke-knowledgebase",
      "iconf": "fill-knowledgebase",
      "icony": "icofont icofont-ui-note",
      "type": "sub",
      "active": false,
      "module_id": 10,
      "children": [
        {
          "path": "/bank_accounts",
          "title": "Bank Accounts",
          "type": "link",
          "active": false
        },
        {
          "path": "/user_accounts",
          "title": "Customer/Dealer Accounts",
          "type": "link",
          "active": false
        },
        {
          "path": "/vendor_credits",
          "title": "Vendor Accounts",
          "type": "link",
          "active": false
        },
        {
          "path": "/payment_in",
          "title": "Payment In",
          "type": "link",
          "active": false
        },
        {
          "path": "/expense",
          "title": "Payment Out",
          "type": "link",
          "active": false
        },
        {
          "path": "/purchase",
          "title": "Purchase",
          "type": "link",
          "active": false
        },
        {
          "path": "/sales",
          "title": "Sales",
          "type": "link",
          "active": false
        },
        {
          "path": "/courier_account",
          "title": "Courier Management",
          "type": "link",
          "active": false
        },
      ]
    },

    {
      "title": "Safe Custody Devices",
      "icon": "stroke-knowledgebase",
      "iconf": "fill-knowledgebase",
      "icony": "icofont icofont-automation",
      "type": "sub",
      "active": false,
      "module_id": 12,
      "children": [
        {
          "path": "/safe_custody",
          "title": "Safe Custody",
          "type": "link",
          "active": false
        },
        {
          "path": "/deactivated_devices",
          "title": "Deactivated Devices",
          "type": "link",
          "active": false
        },
      ]
    },

    {
      "title": "Reports",
      "icon": "stroke-knowledgebase",
      "iconf": "fill-knowledgebase",
      "icony": "icon-files",
      "type": "sub",
      "active": false,
      "module_id": 13,
      "children": [
        {
          "path": "/raw_material_stock_report",
          "title": "Raw Material Report",
          "type": "link",
          "active": false
        },
        {
          "path": "/work_report",
          "title": "Service Report",
          "type": "link",
          "active": false
        },
        {
          "path": "/tag_report",
          "title": "Tag Report",
          "type": "link",
          "active": false
        },
        {
          "path": "/call_log_report",
          "title": "Call Log Report",
          "type": "link",
          "active": false
        },
      ]
    },

    {
      "path": "/products",
      "title": "Products",
      "icon": "stroke-internationalization",
      "iconf": "fill-internationalization",
      "icony": "icofont icofont-box",
      "type": "link",
      "active": false,
      "module_id": 15,
    },

    {
      "path": "/commands",
      "title": "Commands",
      "icon": "stroke-internationalization",
      "iconf": "fill-internationalization",
      "icony": "icofont icofont-speech-comments",
      "type": "link",
      "active": false,
      "module_id": 17,
    },

    {
      "path": "/settings",
      "title": "Settings",
      "icon": "stroke-internationalization",
      "iconf": "fill-internationalization",
      "icony": "icon-settings",
      "type": "link",
      "active": false,
      "module_id": 14,
    },


    // {
    //   "path": "/final_production",
    //   "title": "Final Production",
    //   "icon": "stroke-internationalization",
    //   "iconf":"fill-internationalization",
    //   "icony":"icofont icofont-briefcase-alt-2",
    //   "type": "link",
    //   "active": false
    // },

  ]
}